import { Injectable } from '@angular/core';
import { InventoryComponent } from "@irb/irb-orders/order-blotter/inventory/inventory.component"
import { InlineOrderStatusAction } from "@irb/irb-orders/order-blotter/inventory/inline-order-status-action"
@Injectable({
  providedIn: 'root',
})
export class OrderStatusActionMenu {
  constructor(private inlineOSAction:InlineOrderStatusAction,) { 
  }
  showActions(params:any,formatValue:string, parent:InventoryComponent) {
	if(params && params.data){
    let headerTitle:string = 'Available actions:';
    const item = params.data;
	let menuData =  [];

	const thisOrdStatus = item.orderStatus;
	const thisTktType = item.ticketType;
	const thisSecType = item.securityType;
	const isParent = item.isBlockOrder;

	const veoOrderID = item.veoOrderID;
	const wasOrderMarkAsExecuted = item.wasOrderMarkAsExecuted;
	const allowRevertToApproved = (!veoOrderID || veoOrderID == null) ? true : false;
	const isMutualFund = (thisSecType === "Mutual Fund");
	const isOption = (thisSecType === "Option");
  	const isOptionTradeEnabled: boolean = parent.isOptionTradeEnabled;

	const lang = {
		PLACE_TRADES_ON_HOLD : "Place on hold",
		MANUALLY_SUBMIT : "Manually submit",
		SUBMIT : "Submit",
		CANCEL : "Cancel",
		MARK_AS_EXECUTED : "Mark as executed",
		VALIDATE : "Validate",
		REVERT_TO_APPROVED : "Revert to Approved",
		OVERRIDE : "Override",
		MANUALLY_ALLOCATED : "Manually allocate",
		EXPORT_ALLOCATIONS : "Export allocations",
		REPLACE : "Replace",
		MARK_AS_CANCELED : "Mark as canceled",
		EXPORTED_TO_THINK_PIPES : "Exported to ThinkPipes",
		OVERRIDE_AND_REPLACE : "Override and Replace",
		UNDO_REPLACE_REQUEST : "Undo Replace Request",
	}

	if (!isOptionTradeEnabled && isOption) { 
		headerTitle = 'No available actions';
      /*menuData.push({
        label: ''
      });*/
	} else if(parent.current == "automatedOrders") {
		menuData.push({label: lang.CANCEL,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("CANCEL",item,params,parent)}).bind(this)});
		menuData.push({label: lang.MARK_AS_EXECUTED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MARK_AS_EXECUTED",item, params, parent)}).bind(this)});

		if (thisOrdStatus == "CANCEL_REQUESTED" || thisOrdStatus == "CANCEL_REJECTED") {
			menuData.push({label: lang.MARK_AS_CANCELED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MARK_AS_CANCELLED",item, params, parent)}).bind(this)});
		}
	} else if (thisOrdStatus == "APPROVED" && parent.current == "activeOrders") {
		if (thisTktType == "E") {
			menuData.push({label: lang.SUBMIT,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("SUBMIT",item,params,parent)}).bind(this)});
		}
		
		menuData.push({label: lang.MANUALLY_SUBMIT,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MANUALLY_SUBMIT",item, params, parent)}).bind(this)});
		menuData.push({label: lang.CANCEL,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("CANCEL",item,params,parent)}).bind(this)});
		menuData.push({label: lang.PLACE_TRADES_ON_HOLD,click: (() => {this.inlineOSAction.updateSingleOrderStatus("PLACE_TRADES_ON_HOLD",item, params, parent)}).bind(this)});
		menuData.push({label: lang.MARK_AS_EXECUTED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MARK_AS_EXECUTED",item, params, parent)}).bind(this)});

		if (thisTktType != "M") {
			menuData.push({label: lang.VALIDATE,click: (() => {this.inlineOSAction.updateSingleOrderStatus("VALIDATE",item, params, parent)}).bind(this)});
		}
	} else if (thisOrdStatus == "SUBMITTED_TO_VEO" && veoOrderID && veoOrderID != null) {
		
		menuData.push({label: lang.CANCEL,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("CANCEL",item,params, parent)}).bind(this)});

		if (thisSecType == "Equity" || thisSecType == "Option") {
			menuData.push({label: lang.REPLACE,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("REPLACE",item,params, parent)}).bind(this)});
		}
		menuData.push({label: lang.MARK_AS_EXECUTED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MARK_AS_EXECUTED",item, params, parent)}).bind(this)});
	} else if (thisOrdStatus == "MANUALLY_SUBMITTED") {		
		menuData.push({label: lang.REVERT_TO_APPROVED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("REVERT_TO_APPROVED",item, params, parent)}).bind(this)});
		menuData.push({label: lang.CANCEL,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("CANCEL",item,params, parent)}).bind(this)});
		menuData.push({label: lang.PLACE_TRADES_ON_HOLD,click: (() => {this.inlineOSAction.updateSingleOrderStatus("PLACE_TRADES_ON_HOLD",item, params, parent)}).bind(this)});
		menuData.push({label: lang.MARK_AS_EXECUTED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MARK_AS_EXECUTED",item, params, parent)}).bind(this)});
	} else if (thisOrdStatus == "EXPORTED_TO_THINK_PIPES") {
		menuData.push({label: lang.REVERT_TO_APPROVED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("REVERT_TO_APPROVED",item, params, parent)}).bind(this)});
		menuData.push({label: lang.CANCEL,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("CANCEL",item,params, parent)}).bind(this)});
		menuData.push({label: lang.PLACE_TRADES_ON_HOLD,click: (() => {this.inlineOSAction.updateSingleOrderStatus("PLACE_TRADES_ON_HOLD",item, params, parent)}).bind(this)});
		menuData.push({label: lang.MARK_AS_EXECUTED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MARK_AS_EXECUTED",item, params, parent)}).bind(this)});
	} else if (thisOrdStatus == "ON_HOLD") {
		menuData.push({label: lang.REVERT_TO_APPROVED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("REVERT_TO_APPROVED",item, params, parent)}).bind(this)});
		menuData.push({label: lang.CANCEL,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("CANCEL",item,params, parent)}).bind(this)});
	} else if (thisOrdStatus == "CANCELLED_PARTIALLY_FILLED" || thisOrdStatus == "CANCELLED_NO_FILL" || thisOrdStatus == "MARK_AS_CANCELLED" || thisOrdStatus == "FILLED"
		 && (!isParent || isParent == null)) {
		headerTitle = 'No available actions';
	} else if (thisOrdStatus == "CANCEL_REQUESTED" || thisOrdStatus == "CANCEL_REJECTED") {
		menuData.push({label: lang.MARK_AS_CANCELED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MARK_AS_CANCELLED",item, params, parent)}).bind(this)});
	} else if (thisOrdStatus == "ALLOCATIONS_SENT" || thisOrdStatus == "PARTIALLY_FILLED") {
        menuData.push({label: lang.CANCEL,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("CANCEL",item,params, parent)}).bind(this)});
		if (thisOrdStatus == "PARTIALLY_FILLED" && (thisSecType == "Equity" || thisSecType == "Option")) {
			menuData.push({label: lang.REPLACE,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("REPLACE",item, params, parent)}).bind(this)});
		}
	} else if (thisOrdStatus == "PENDING_VALIDATION") {
		menuData.push({label: lang.REVERT_TO_APPROVED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("REVERT_TO_APPROVED",item, params, parent)}).bind(this)});
		menuData.push({label: lang.CANCEL,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("CANCEL",item, params, parent)}).bind(this)});
		menuData.push({label: lang.PLACE_TRADES_ON_HOLD,click: (() => {this.inlineOSAction.updateSingleOrderStatus("PLACE_TRADES_ON_HOLD",item, params, parent)}).bind(this)});
	} else if ((thisOrdStatus == "CANCELLED" || thisOrdStatus == "CANCELLED_WITH_NO_FILL" || thisOrdStatus == "MARK_AS_EXECUTED") && allowRevertToApproved) { //IREBAL-35317
		menuData.push({label: lang.REVERT_TO_APPROVED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("REVERT_TO_APPROVED",item, params, parent)}).bind(this)});
	} else if (thisOrdStatus == "REJECTED" || thisOrdStatus == "ERROR") {
		
		menuData.push({label: lang.REVERT_TO_APPROVED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("REVERT_TO_APPROVED",item, params, parent)}).bind(this)});
		menuData.push({label: lang.CANCEL,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("CANCEL",item, params, parent)}).bind(this)});
		menuData.push({label: lang.PLACE_TRADES_ON_HOLD,click: (() => {this.inlineOSAction.updateSingleOrderStatus("PLACE_TRADES_ON_HOLD",item, params, parent)}).bind(this)});
		menuData.push({label: lang.MARK_AS_EXECUTED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MARK_AS_EXECUTED",item, params, parent)}).bind(this)});

		if (thisTktType != "M") {
			menuData.push({label: lang.VALIDATE,click: (() => {this.inlineOSAction.updateSingleOrderStatus("VALIDATE",item, params, parent)}).bind(this)});
		}
	} else if (thisOrdStatus == "VALIDATED" || thisOrdStatus == "OVERRIDDEN" || thisOrdStatus == "WARNING") {
		menuData.push({label: lang.REVERT_TO_APPROVED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("REVERT_TO_APPROVED",item, params, parent)}).bind(this)});
		if (thisOrdStatus == "VALIDATED" || thisOrdStatus == "OVERRIDDEN") {
			menuData.push({label: lang.SUBMIT,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("SUBMIT",item, params, parent)}).bind(this)});
		}
		
		menuData.push({label: lang.MANUALLY_SUBMIT,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MANUALLY_SUBMIT",item, params, parent)}).bind(this)});
		menuData.push({label: lang.CANCEL,click: (() => {this.inlineOSAction.inlineGridActionTypeCheckWarnings("CANCEL",item, params, parent)}).bind(this)});
		menuData.push({label: lang.PLACE_TRADES_ON_HOLD,click: (() => {this.inlineOSAction.updateSingleOrderStatus("PLACE_TRADES_ON_HOLD",item, params, parent)}).bind(this)});
		menuData.push({label: lang.MARK_AS_EXECUTED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MARK_AS_EXECUTED",item, params, parent)}).bind(this)});

		if (thisTktType != "M") {
			menuData.push({label: lang.VALIDATE,click: (() => {this.inlineOSAction.updateSingleOrderStatus("VALIDATE",item, params, parent)}).bind(this)});
		}

		if (thisOrdStatus == "WARNING") {
			menuData.push({label: lang.OVERRIDE,click: (() => {this.inlineOSAction.updateSingleOrderStatus("OVERRIDE",item, params, parent)}).bind(this)});
		}
	} else if (thisOrdStatus == "SUBMITTED_TO_VEO") {
		if (isMutualFund && !veoOrderID) {
			menuData.push({label: lang.MARK_AS_EXECUTED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MARK_AS_EXECUTED",item, params, parent)}).bind(this)});
		} else {
			headerTitle = 'No available actions';
		}
	} else if (thisOrdStatus == "REPLACE_WARNING") {
		menuData.push({label: lang.OVERRIDE_AND_REPLACE,click: (() => {this.inlineOSAction.updateSingleOrderStatus("OVERRIDE_AND_REPLACE",item, params, parent)}).bind(this)});
		menuData.push({label: lang.UNDO_REPLACE_REQUEST,click: (() => {this.inlineOSAction.updateSingleOrderStatus("UNDO_REPLACE_REQUEST",item, params, parent)}).bind(this)});
	}

	if (isParent && isParent != null && ((isOptionTradeEnabled && isOption) || !isOption)) {
		if (thisOrdStatus == "ALLOCATIONS_FAILED") {
			menuData = [];
			menuData.push({label: lang.MANUALLY_ALLOCATED,click: (() => {this.inlineOSAction.updateSingleOrderStatus("MANUALLY_ALLOCATE",item, params, parent)}).bind(this)});
			menuData.push({label: lang.EXPORT_ALLOCATIONS,click: (() => {this.inlineOSAction.exportAllocations(item,parent)}).bind(this)});
		} else if(parent.current != "automatedOrders") {
			menuData.push({label: lang.EXPORT_ALLOCATIONS,click: (() => {this.inlineOSAction.exportAllocations(item,parent)}).bind(this)});
		}
	}
    return {
      component: "cellRendererFormatter",
      params: { value: formatValue, menuHeaderTitle: headerTitle,irbCellActionMenu: menuData}
	}
	}
  }
  
}